import { render, staticRenderFns } from "./UserGroupEdit.vue?vue&type=template&id=6feb86c8&"
import script from "./UserGroupEdit.vue?vue&type=script&lang=ts&"
export * from "./UserGroupEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports